import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class ProductBlock extends Component {
  render() {
    const {
      user,
      id,
      label,
      price,
      imageUrl,
      handleLoad,
      animationDelayz,
      doDelete,
      product,
    } = this.props;

    return (
      <div
        className='product'
        style={{ animationDelay: `${animationDelayz}s` }}
      >
        <Link onClick={handleLoad} to={`/products/product/${id}`}>
          <div className='product-block-image'>
            <img
              className='product-block-image-inside'
              width='100%'
              src={imageUrl}
              alt=''
            />
          </div>
          <hr />
          <h4>{label}</h4>
          <h5>PKR {price}</h5>
        </Link>

        {doDelete && user && user.isAdmin  && (
          <div className='product-inner-btns'>
            <button style={{marginBottom: '0px'}} onClick={() => doDelete(product)} className='delete-pro'>
              Delete
            </button>
            <Link to={`/add-new-product/${id}`}>
              <button style={{marginTop: '0px'}} className='update-pro'>Update</button>
            </Link>
          </div>
        )}
      </div>
    );
  }
}

export default ProductBlock;
